<template>
	<div class="index_main">
		<div class="main">
			<div class="main_title">
				<div class="title">About us</div>
				<div class="subtitle"><span></span>关于我们<span></span></div>
			</div>
			<div class="column_info" v-html="about">
				<!-- <div class="left">
					<div class="title">
						学易点教育科技有限公司
						<span>Xueyidian Education Technology Co., Ltd</span>
					</div>
					<div class="icon1"></div>
					<div class="text">
						上海助佳实业有限公司成立于2013年，以房地产、运营外卖平台为一体的实业有限公司。响应一带一路的号召，踏出国门，挺近东南亚。
					</div>
					<div class="link">
						查看更多
					</div>
				</div>
				<div class="right">
					<el-image src="./static/images/gs.png" fit="contain"> </el-image>
					<div class="bg"></div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import mixins from '@/mixins/index'
	export default {
		mixins: [mixins],
		data() {
			return {
				about: ''
			}
		},
		mounted() {
			this.handindex()
		},
		methods: {
			handindex() {
				this.request({
					url: '/index/guanwang/about_us',
					data: {},
					success: (res) => {
						if (res.code == 200) {
							this.about = res.data.info
						}
					}
				})

			}
		}
	}
</script>

<style lang="scss" scoped>
	.index_main {
		position: relative;
		display: flex;
		align-items: center;
		flex-direction: column;

		.main {
			max-width: 1200px;
			width: 100%;
			display: flex;
			flex-direction: column;

			.main_title {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 30px 0;

				.title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 26px;
					color: #333;
					font-weight: bold;

				}

				.subtitle {
					display: flex;
					align-items: center;
					font-size: 24px;
					font-weight: 400;
					color: #333;
					margin-top: 20px;

					span {
						display: block;
						width: 80px;
						height: 1px;
						background: #000000;
						margin: 0 40px;
					}
				}
			}

			.column_info {
				max-width: 1200px;
				width: 100%;
				min-height: 350px;
				// display: flex;
				// align-items: center;
				// justify-content: space-between;
				// margin-bottom: 50px;
				// margin-top: 60px;

				.left {
					width: 560rpx;
					height: 350px;
					display: flex;
					justify-content: space-between;
					flex-direction: column;

					.title {
						display: flex;
						flex-direction: column;
						font-size: 18px;
						font-weight: bold;
						color: #000000;
						line-height: 30px;

						span {
							font-size: 12px;
							color: #999999;
							line-height: 30px;
						}
					}

					.icon1 {
						width: 36px;
						height: 4px;
						background: #2D82FF;
					}

					.text {
						width: 560px;
						padding-top: 60px;
						height: 250px;
						font-size: 16px;
						font-weight: 400;
						color: #666666;
						line-height: 42px;
					}

					.link {
						width: 114px;
						height: 42px;
						background: #2D82FF;
						font-size: 14px;
						color: #fff;
						display: flex;
						align-items: center;
						justify-content: center;
						opacity: 0;
					}
				}

				.right {
					width: 565px;
					height: 350px;
					position: relative;

					.el-image {
						width: 510px;
						height: 295px;
						border-radius: 8px;
						position: absolute;
						z-index: 3;
					}

					.bg {
						width: 478px;
						height: 266px;
						background: #2D82FF;
						border-radius: 8px;
						position: absolute;
						right: 0;
						bottom: 0;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/about/about.vue